import { FormControl, FormControlLabel, FormHelperText, GridLegacy as Grid, Stack, styled } from '@mui/material'
import { Checkbox } from 'ComponentLibrary/src/piazza/selectors'
import { get } from 'lodash'
import { Control, Controller, FieldErrors, FieldValues, Path } from 'react-hook-form'
import { InfoTooltip } from 'ComponentLibrary/src/atoms/IconTooltip'
import { tokens } from 'ComponentLibrary/style-dictionary/output'

type FormCheckboxProps<TFieldValues extends FieldValues> = {
    fieldName: Path<TFieldValues>
    fullWidth?: boolean
    xs?: number
    required?: boolean
    control: Control<TFieldValues>
    errors: FieldErrors<TFieldValues>
    disabled?: boolean
    label?: string
    infoText?: string
}

const FormCheckbox = <TFieldValues extends FieldValues>({
    fieldName,
    fullWidth,
    xs,
    control,
    errors,
    required,
    disabled,
    label,
    infoText,
}: FormCheckboxProps<TFieldValues>) => {
    const error = get(errors, fieldName)
    const errorMessage = error?.message?.toString()
    return (
        <Grid xs={fullWidth ? 12 : xs} item display="flex" justifyContent="center">
            <Stack direction="row" width="100%" gap={tokens.SizingSpacing075} alignItems="center">
                <Controller
                    name={fieldName}
                    control={control}
                    rules={{ required: required ? { value: true, message: 'Pflichtfeld' } : undefined }}
                    // we ignore ref from fieldProps since checkbox does not accept it
                    render={({ field: { value, onChange, ref: _, ...fieldProps } }) => {
                        return (
                            <StyledFormControlLabel
                                required={required}
                                style={{ margin: 0 }}
                                disabled={disabled}
                                label={label}
                                control={
                                    <FormControl>
                                        <Checkbox
                                            checked={value}
                                            disabled={disabled}
                                            onChange={(event) => onChange(event)}
                                            {...fieldProps}
                                        />
                                        <FormHelperText
                                            error
                                            variant="outlined"
                                            margin="dense"
                                            sx={{ fontSize: '0.5rem', position: 'absolute', bottom: '-1px', whiteSpace: 'nowrap' }}
                                        >
                                            {errorMessage || ' '}
                                        </FormHelperText>
                                    </FormControl>
                                }
                            />
                        )
                    }}
                />
                {infoText && <InfoTooltip text={infoText} />}
            </Stack>
        </Grid>
    )
}

export default FormCheckbox

const StyledFormControlLabel = styled(FormControlLabel)(({ label }) => ({
    gap: tokens.SizingSpacing100,
    borderRadius: label ? '4px' : '100%',
}))
